import { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import s from '../../../pages/CaseFilePage/CaseFilePage.module.css';

interface ModalOverlayProps {
  children: React.ReactNode;
  title: React.ReactNode;
  onClose: () => void;
  wide?: boolean;
}

export default function ModalOverlay({ children, title, onClose, wide }: ModalOverlayProps) {
  const overlayRef = useRef<HTMLDivElement>(null);

  return (
    <div
      className={s.overlay}
      ref={overlayRef}
      onClick={(e) => {
        if (e.target === overlayRef.current) onClose();
      }}
    >
      <div className={`${s.modal} ${wide ? s.modalWide : ''}`}>
        <div className={s.modalHeader}>
          <h3>{title}</h3>
          <button className={s.modalClose} onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className={s.modalBody}>{children}</div>
      </div>
    </div>
  );
}
